import { Chip } from "@mui/material";
import React, { useContext, useState } from "react";
import { Col, Row, Spinner, Table } from "react-bootstrap";
import { FiBook } from "react-icons/fi";
import { IoDocument } from "react-icons/io5";
import { useQuery } from "react-query";
import {
  BarChart,
  Bar,
  Cell,
  XAxis,
  YAxis,
  CartesianGrid,
  Tooltip,
  Legend,
  ResponsiveContainer,
  LineChart,
  Line,
  PieChart,
  Pie,
} from "recharts";
import {
  CiBadgeDollar,
  CiCircleMinus,
  CiPercent,
  CiReceipt,
  CiSquareCheck,
} from "react-icons/ci";
import {
  PiCaretDownFill,
  PiCaretUpFill,
  PiCheckCircleFill,
  PiWarningFill,
} from "react-icons/pi";
import { checkExportMandateReportNew, getAllMandates, getInsufficientReports, getMandateReportNewExport, getMyMandates, getTransactions, metricsSmms } from "../services";
import { FaLock, FaLockOpen, FaMoneyBill } from "react-icons/fa";
import { notify } from "../components/actions/CommonActions";
import { grey, red } from "@mui/material/colors";
import { AuthContext } from "../helpers/AuthContext";
import { GoDownload } from "react-icons/go";
import { MdOutlineCancel } from "react-icons/md";

export const InsufficientReports = () => {
  const [transactions, setTransactions] = useState();
  const [mandates, setMandates] = useState();
  const [statusCounts, setStatusCounts] = useState([]);
  const { user, statuses } = useContext(AuthContext);
  const formatDate = (date) => date.toISOString().split("T")[0];
  const [startDate, setStartDate] = useState(formatDate(new Date()));
  const [endDate, setEndDate] = useState(formatDate(new Date()));
        const [isLoading, setIsLoading] = useState(false);
  const [sortedMandatesByNextDebitDate, setSortedMandatesByNextDebitDate] =
    useState();

  const numberFormat = (value, toFixed = 2) => {
    return Number(value)
      .toFixed(toFixed)
      .replace(/\d(?=(\d{3})+\.)/g, "$&,");
  };


  const {} = useQuery(
    "my-mandates",
    () => {
      if (user?.userData?.role === 999) {
        return getMyMandates(user?.userData?.id);
      } else {
        return getAllMandates();
      }
    },
    {
      onSuccess: (res) => {
        setMandates(res);
        // console.log("this is res", res);
        const approverStatuses = res?.data?.map(
          (entry) => entry.approverStatus
        );
        const statusCountsObj = approverStatuses.reduce((acc, status) => {
          const statusName =
            statuses?.data?.find((s) => s.id === status)?.name || "Unknown";
          acc[statusName] = (acc[statusName] || 0) + 1;
          return acc;
        }, {});

        const statusCountsArray = Object.keys(statusCountsObj).map(
          (statusName) => ({
            approverStatus: statusName,
            count: statusCountsObj[statusName],
          })
        );

        setStatusCounts(statusCountsArray);

        // =========================================================================================================

        const sortedData = [...res?.data].sort((a, b) => {
          const dateA = new Date(a.nextDebitDate);
          const dateB = new Date(b.nextDebitDate);

          return dateA - dateB;
        });

        const top5Data = sortedData.slice(0, 5);

        setSortedMandatesByNextDebitDate(top5Data);

        // console.log(res?.data, top5Data);

        // =========================================================================================================
      },
      onError: (error) => {
        notify("danger", "Error", "Something went wrong");
        console.log(error);
      },
    }
  );


  const { data: metricsData, isLoading: loadingMetrics, isError, error } = useQuery({
  queryKey: ['getInsufficientReports'],
  queryFn: getInsufficientReports,
});

const handleExportHistory = async (page, limit) => {
  const params = {
    // limit,
    // page,
    from: startDate,
    to: endDate,
    // export: true,
  };

  const searchParams = new URLSearchParams();
  Object.entries(params).forEach(([key, value]) => {
    if (value) {
      searchParams.append(key, value);
    }
  });

  try {
    await getMandateReportNewExport(searchParams);
  } catch (err) {
    console.log('Export error:', err);
  }
};

// console.log("metrics data: ", metricsData?.data?.data[0]?.summary?.summary);
 const handleCheckDownload = async () => {
        const params = {
            // status: status,
            from: startDate,
            to: endDate
        }

        const searchParams = new URLSearchParams()
        // Add parameters only if they are defined and not empty
        Object.entries(params).forEach(([key, value]) => {
            if (value) {
                searchParams.append(key, value);
            }
        });
                setIsLoading(true)

        await checkExportMandateReportNew(searchParams)
            .then(async (res) => {
                  // console.log("transaction history res ", res);
                  if(res?.canExport == false){
                    notify("danger", "OOPS", `${res?.message}`);
                  }
                  if(res?.count > 0){
                    await handleExportHistory()
                  }
                // setShowSingleDebitModal(false)
                // setFaReport(res?.data)
            })
            .catch((err) => {
                setIsLoading(false)
                notify("danger", "OOPS", `${err?.response?.data?.message}`);
                console.log('err ', err);
            })
                setIsLoading(false)
    }


  return (
    <>
    {loadingMetrics? 
     <div className="d-flex justify-content-center align-items-center vh-100">
      <Spinner animation="border" variant="primary" role="status">
        <span className="visually-hidden">Loading...</span>
      </Spinner>
    </div>
    :
    <div>
      <div style={{display: "flex", justifyContent: "space-between", alignItems: "flex-end", marginTop: "10px"}}>
        <div style={{display: "flex"}}>
                    </div>
                    <div>
                              <button type="button" onClick={handleCheckDownload} style={{ border: "none", backgroundColor: "#007dcc", color: "white", padding: "4px 10px", borderRadius: "5px", marginLeft: "10px" }}><GoDownload color="white" />Export</button>
                              </div>
      </div>
    <div
        className="d-flex align-items-center justify-start gap-2 mt-3"
        style={{ height: "98px" }}
      >
        <div
          className="w-25 h-100 rounded p-2 d-flex align-items-center justify-content-between flex-direction-row"
          style={{ border: "1px solid #d4d4d8" }}
        >
          <div>
            <p className="mb-3 text-muted" style={{ fontSize: "0.9rem" }}>
              Total distinct mandates 
            </p>
            <h5 className="mb-0" style={{ color: "#000" }}>
              {metricsData?.data?.data[0]?.distinctMandates?.toLocaleString()}
            </h5>
          </div>

          <div
            className="rounded-circle d-flex align-items-center justify-content-center"
            style={{
              width: "35px",
              height: "35px",
              backgroundColor: "#e6f2fa",
            }}
          >
            <CiBadgeDollar
              style={{ fontSize: "1.5rem" }}
              className="text-primary"
            />
          </div>
        </div>
        <div
          className="w-25 h-100 rounded p-2 d-flex align-items-center justify-content-between flex-direction-row ml-3"
          style={{ border: "1px solid #d4d4d8" }}
        >
          <div>
            <p className="mb-3 text-muted" style={{ fontSize: "0.9rem" }}>
              Total successful mandate debitted
            </p>
            <h5 className="mb-0" style={{ color: "#000" }}>
              {metricsData?.data?.data[0]?.successCount?.toLocaleString()}
            </h5>
          </div>

          <div
            className="rounded-circle d-flex align-items-center justify-content-center"
            style={{
              width: "35px",
              height: "35px",
              backgroundColor: "#e6f2fa",
            }}
          >
            <CiSquareCheck
              style={{ fontSize: "1.3rem" }}
              className="text-primary"
            />
          </div>
        </div>
        <div
          className="w-25 h-100 rounded p-2 d-flex align-items-center justify-content-between flex-direction-row ml-3"
          style={{ border: "1px solid #d4d4d8" }}
        >
          <div>
            <p className="mb-3 text-muted" style={{ fontSize: "0.9rem" }}>
              Failed count
            </p>
            <h5 className="mb-0" style={{ color: "#000" }}>
              {metricsData?.data?.data[0]?.failedCount?.toLocaleString()}
            </h5>
          </div>

          <div
            className="rounded-circle d-flex align-items-center justify-content-center"
            style={{
              width: "35px",
              height: "35px",
              backgroundColor: "#faede6ff",
            }}
          >
            <MdOutlineCancel
              style={{ fontSize: "1.3rem", color: "red" }}
            //   className="text-primary"
            />
          </div>
        </div>
        <div
          className="w-25 h-100 rounded p-2 d-flex align-items-center justify-content-between flex-direction-row ml-3"
          style={{ border: "1px solid #d4d4d8" }}
        >
          <div>
            <p className="mb-3 text-muted" style={{ fontSize: "0.9rem" }}>
              Total successful amount
            </p>
            <h5 className="mb-0" style={{ color: "#000" }}>
              {metricsData?.data?.data[0]?.totalSuccessAmount?.toLocaleString()}
            </h5>
          </div>

          <div
            className="rounded-circle d-flex align-items-center justify-content-center"
            style={{
              width: "35px",
              height: "35px",
              backgroundColor: "#e6f2fa",
            }}
          >
            <CiSquareCheck
              style={{ fontSize: "1.3rem" }}
              className="text-primary"
            />
          </div>
        </div>
      </div>
    <p style={{fontWeight: "500", fontSize: 18, marginTop: "10px"}}>Summary:</p>
    <table className="fl-table">
                  <thead>
                    <tr style={{ borderBottom: "0.5px solid #f1f1f1" }}>
                      {/* Table header cells */}
                      {/* Modify according to your data structure */}
                      <th width="20%">Error code</th>
                      <th>Error message</th>
                      <th>Count</th>
                    </tr>
                  </thead>
                  <tbody>
                    {
                      metricsData?.data?.data[0]?.summary?.summary?.map((mandate, index) => (
                        <tr
                          className="hover-detail"
                          key={index}
                        //   onClick={() => {
                        //     navigate(`/all-mandates/${id}/${mandate?.workFlowStatus}`)
                        //   }}
                        >
                          <td className="gray-td">{mandate?.errorCode}</td>
                          <td className="gray-td">{mandate?.errorMessage}</td>
                          <td className="gray-td">{mandate?.counter}</td>
                        </tr>
                      ))}
                  </tbody>
                </table>

                </div>}
      {/* <div
        className="d-flex align-items-center justify-content-between gap-2 mt-3"
        style={{ height: "98px" }}
      >
        <div
          className="w-25 h-100 rounded p-2 d-flex align-items-center justify-content-between flex-direction-row"
          style={{ border: "1px solid #d4d4d8" }}
        >
          <div>
            <p className="mb-3 text-muted" style={{ fontSize: "0.9rem" }}>
              Transactions count
            </p>
            <h5 className="mb-0" style={{ color: "#000" }}>
              {numberFormat(124567)}
            </h5>
          </div>

          <div
            className="rounded-circle d-flex align-items-center justify-content-center"
            style={{
              width: "35px",
              height: "35px",
              backgroundColor: "#e6f2fa",
            }}
          >
            <CiBadgeDollar
              style={{ fontSize: "1.5rem" }}
              className="text-primary"
            />
          </div>
        </div>
        <div
          className="w-25 h-100 rounded p-2 d-flex align-items-center justify-content-between flex-direction-row ml-3"
          style={{ border: "1px solid #d4d4d8" }}
        >
          <div>
            <p className="mb-3 text-muted" style={{ fontSize: "0.9rem" }}>
              Successful transactions
            </p>
            <h5 className="mb-0" style={{ color: "#000" }}>
              {numberFormat(124567)}
            </h5>
          </div>

          <div
            className="rounded-circle d-flex align-items-center justify-content-center"
            style={{
              width: "35px",
              height: "35px",
              backgroundColor: "#e6f2fa",
            }}
          >
            <CiSquareCheck
              style={{ fontSize: "1.3rem" }}
              className="text-primary"
            />
          </div>
        </div>
        <div
          className="w-25 h-100 rounded p-2 d-flex align-items-center justify-content-between flex-direction-row ml-3"
          style={{ border: "1px solid #d4d4d8" }}
        >
          <div>
            <p className="mb-3 text-muted" style={{ fontSize: "0.9rem" }}>
              Failed transactions
            </p>
            <h5 className="mb-0" style={{ color: "#000" }}>
              {numberFormat(124567)}
            </h5>
          </div>

          <div
            className="rounded-circle d-flex align-items-center justify-content-center"
            style={{
              width: "35px",
              height: "35px",
              backgroundColor: "#e6f2fa",
            }}
          >
            <CiCircleMinus
              style={{ fontSize: "1.3rem" }}
              className="text-primary"
            />
          </div>
        </div>
        <div
          className="w-25 h-100 rounded p-2 d-flex align-items-center justify-content-between flex-direction-row ml-3"
          style={{ border: "1px solid #d4d4d8" }}
        >
          <div>
            <p className="mb-3 text-muted" style={{ fontSize: "0.9rem" }}>
              Mandates count
            </p>
            <h5 className="mb-0" style={{ color: "#000" }}>
              {numberFormat(124567)}
            </h5>
          </div>

          <div
            className="rounded-circle d-flex align-items-center justify-content-center"
            style={{
              width: "35px",
              height: "35px",
              backgroundColor: "#e6f2fa",
            }}
          >
            <CiReceipt
              style={{ fontSize: "1.6rem" }}
              className="text-primary"
            />
          </div>
        </div>
      </div> */}
    </>

    //   <div id="detail"></div>
  );
};
